// Minimize scroll jank by using requestAnimationFrame
const onScroll = callback => {
  let waiting = false;
  window.addEventListener("scroll", () => {
    if (!waiting) {
      waiting = true;
      window.requestAnimationFrame(() => {
        waiting = false;
        callback();
      });
    }
  });
};

const offsetScroll = () => {
  // Capture internal links and scroll past the nav
  document.querySelectorAll('a[href*="#"]:not([href="#"])').forEach(el =>
    el.addEventListener("click", event => {
      event.preventDefault();

      let targetEl = document.querySelector(event.currentTarget.hash);
      if (!targetEl) {
        return;
      }
      // Gotta turn on the sticky bar to get its height
      document.body.classList.add("use-sticky");

      let navEl = document.querySelector(".is-sticky");
      let navHeight = navEl ? navEl.clientHeight : 0;

      let rect = targetEl.getBoundingClientRect();
      window.scrollBy(rect.left, rect.top - navHeight);
    })
  );
};

let navpos = document.getElementById("navposition");

if (navpos) {
  onScroll(() =>
    document.body.classList.toggle(
      "use-sticky",
      window.scrollY >= navpos.offsetTop
    )
  );

  offsetScroll();
}
